import { useEffect, useState } from "react";
import { useReasonLeaveContext } from "api/settings/reason-leave/ReasonLeaveProvider";
import { FormattedMessage } from "react-intl";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TableManager } from "components/bo/admin-table/TableManager";
import { ACTIONS, ENTITIES } from "constants/constants";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import Button from "core/buttons/button/Button";

export default function AdminReasonLeave({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    reasonLeaveByIdGetter,
    reasonLeaveCreate,
    reasonLeaveDeleteById,
    reasonLeaveList,
    reasonLeaveListGetter,
    reasonLeavePerId,
    reasonLeaveUpdateById,
  } = useReasonLeaveContext();

  const reasonLeaveForm = [
    { col: "id", mandatory: true, isMissingValue: null },
    { col: "en", mandatory: true, isMissingValue: null },
    { col: "fr", mandatory: true, isMissingValue: null },
  ];
  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    reasonLeaveListGetter();
  }, [reasonLeaveListGetter]);

  useEffect(() => {
    if (id) {
      reasonLeaveByIdGetter(id);
    }
  }, [id]);

  const handleDelete = async (reasonLeaveId) =>
    setDeleteData(reasonLeaveList.find((e) => e.id === reasonLeaveId));

  const validateDelete = async (reasonLeaveId) => {
    try {
      await reasonLeaveDeleteById(reasonLeaveId);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCreate = (payload) => {
    try {
      reasonLeaveCreate(payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  const handleEdit = (payload) => {
    try {
      reasonLeaveUpdateById(payload.id, payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  // Todo gestion droits admin
  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.REASON_LEAVE}
        entityPerId={reasonLeavePerId}
        list={reasonLeaveList}
        inputs={reasonLeaveForm}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />

      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={validateDelete}
          deleteData={deleteData}
          entity={ENTITIES.REASON_LEAVE}
        />
      </div>
    </div>
  );
}
